module.exports = __webpack_public_path__ + "img/051.28dbda78.jpg";